const trimDecimals = (value, decimals = 2) => {
  let fValue = parseFloat(value);
  if (!value || isNaN(fValue)) return 0;
  fValue = fValue.toFixed(12);
  return parseFloat(fValue.substring(0, fValue.indexOf('.') + (decimals + 1)));
};

export default trimDecimals;
